// src/pages/LoaderPage.jsx
import React, { useState, useEffect } from "react";
import LoadingOverlay from "../shared/LoadingOverlay";

export default function LoaderPage() {
    const messages = [
        "Initializing eFolder process...",
        "Creating document order...",
        "Polling document status...",
        "Adding documents to eFolder...",
        "Finalizing..."
    ];

    const [currentMsg, setCurrentMsg] = useState(messages[0]);
    const [index, setIndex] = useState(0);

    // Rotate messages every 2 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((i) => {
                const next = i + 1;
                setCurrentMsg(messages[next] || "Completing process...");
                return next >= messages.length ? messages.length - 1 : next;
            });
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <LoadingOverlay loading={true} text={currentMsg} />
        </div>
    );
}
